// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_mo-0";
export var fileCarousel = "_mo-2";
export var removeFileButton = "_mo-1";